module.exports = __webpack_public_path__ + "img/ritchie.1ae67d15.png";